import React from 'react';
import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  createComponentExtension,
} from '@backstage/core-plugin-api';
import { techRadarApiRef as communityTechRadarApiRef } from '@backstage-community/plugin-tech-radar';

import { adminRouteRef, homeRouteRef } from './routes';
import { techRadarApiRef, TechRadarClient } from './api';
import { TechRadarRadarClient } from './api/TechRadarRadarClient';
import { createFrontendPlugin, PageBlueprint, ApiBlueprint } from '@backstage/frontend-plugin-api';




const homePage = PageBlueprint.make({
  name: 'tech-radar-home',
  params: {
    routeRef: homeRouteRef,
    path: '/tech-radar',
    loader: () => import('./components/TechRadarPage').then(m => <m.TechRadarPage />)
  },
});
const adminPage = PageBlueprint.make({
  name: 'tech-radar-admin',
  params: {
    routeRef: adminRouteRef,
    path: '/admin/tech-radar',
    loader: () => import('./components/TechRadarAdminPage').then(m => <m.TechRadarAdminPage />)
  },
});

const techRadarApi = ApiBlueprint.make({
  name: 'tech-radar-api',
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechRadarClient({ discoveryApi, fetchApi }),
    }),
});

const techRadarCommunityApi = ApiBlueprint.make({
  name: 'tech-radar-community-api',
  params: defineParams =>
    defineParams({
      api: communityTechRadarApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new TechRadarRadarClient({ discoveryApi, fetchApi, identityApi }),
    }),
});


export const techRadarFrontendPlugin = createFrontendPlugin({
  pluginId: "tech-radar",
  extensions: [homePage, adminPage, techRadarApi, techRadarCommunityApi],
  routes: {
    home: homeRouteRef,
    admin: adminRouteRef,
  },

});